module.exports = __webpack_public_path__ + "img/6354855032840277298850341.e06967c0.jpg";